<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'production-orderTechPricing',
  components: { PageTable },
}
</script>
